<div class="card mb-4">
	<div class="card-header">
		<h1>Suspensiones a Empleados</h1>
	</div>
	<div class="card-body">
		<div class="row">
			<div class="col-sm">
				<h5>Configuración de Suspensión</h5>
				<div class="row mb-1">
					<div class="col-sm-6 form-group">
						<label for="paymentType" class="form-label">Tipo de suspensión</label>
						<select name="paymentType" id="paymentType" class="form-select"
							[(ngModel)]="suspensionRequest.type">
							<option value="undefined" disabled>Selecciona</option>
							<option value="1">Problemas de Salud</option>
							<option value="2">Inicidentes</option>
							<option value="3">Solicitud</option>
							<option value="4">Otros</option>
						</select>
					</div>
					<div class="col-sm-6 form-group">
						<label for="paymentType" class="form-label">Estado de Pago</label>
						<select name="paymentType" id="paymentType" class="form-select"
							[(ngModel)]="suspensionRequest.paidStatus">
							<option value="undefined" disabled>Selecciona</option>
							<option value="0">No Pagado</option>
							<option value="1">Pagado</option>
							<option value="3">Parcialmente Pagado</option>
						</select>
					</div>
				</div>
				<div class="row mb-1">
					<div class="col-sm-6 form-group">
						<label for="suspensionDate" class="form-label">Fecha de Inicio</label>
						<input type="date" name="suspensionDate" id="suspensionDate" [(ngModel)]="suspensionRequest.suspensionDate"
							class="form-control">
					</div>
					<div class="col-sm-6 form-group">
						<label for="returnDate" class="form-label">Fecha de Retorno (Opcional)</label>
						<input type="date" name="returnDate" id="returnDate" [(ngModel)]="suspensionRequest.returnDate"
							class="form-control">
					</div>
				</div>
				<div class="form-group">
					<label for="description" class="form-label">Razón</label>
					<textarea name="description" placeholder="Ingresa una descripción" id="description" class="form-control"
						[(ngModel)]="suspensionRequest.reason" cols="30" rows="5"></textarea>
				</div>
			</div>
			<div class="col-sm">
				<h5>Empleados</h5>
				<div class="form-group">
					<label for="filter" class="form-label">
						Filtra
					</label>
					<input type="text" placeholder="Ingresa el nombre o la identificacion" id="filter" (input)="filter($event)" name="filter" class="form-control">
					<p *ngIf="numberContracted > 0" class="form-text"><i class="fa fa-user"></i>Has seleccionado a <b style="font-size: 1.1rem;">{{numberContracted}}</b> empleados
					</p>
				</div>
				<div class="table-responsive mt-2" style="max-height: 250px;">
					<table class="table table-bordered caption-top">
						<thead>
							<tr>
								<th class="td-center">Identificacion</th>
								<th>Nombre</th>
								<td></td>
							</tr>
						</thead>
						<tbody>
                            <ng-container *ngFor="let employee of contractedPersonal">
								<tr [ngClass]="employeeSelected==employee.id?'selected-employee':'no-selected-employee'"
									>
									<td class="td-center">
										{{employee.identificacion}}
									</td>
									<td>
										{{employee.nombre}}
									</td>
									<td class="td-center">
										<i (click)="setSelected(employee)"
											[ngClass]="employeeSelected==employee.id?'fa fa-circle-check':'fa-regular fa-circle'"></i>
									</td>
								</tr>
							</ng-container>
							<tr *ngIf="contractedPersonal.length == 0">
								<td colspan="3"><i class="fa fa-circle-info"></i>No existen empleados para el filtro ingresado</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
	<div class="card-footer">
		<button class="btn btn-success" (click)="createSuspension()" [disabled]="suspensionRequest.suspensionDate=='' || !suspensionRequest.paidStatus || !suspensionRequest.type || suspensionRequest.reason=='' || !employeeSelected">
			<i *ngIf="!saving" class="fa fa-save"></i>
			<span *ngIf="saving" class="spinner-border spinner-border-sm"></span>
			GUARDAR
		</button>
	</div>
</div>

<div class="card">
	<div class="card-header">
		<h1>Suspensiones Activas</h1>
	</div>
	<div class="card-body">
		<div class="row">
			<div class="row mb-1">
				<div class="col-sm form-group">
					<label for="suspensionDate" class="form-label">Inicio</label>
					<input type="date" name="suspensionDate" id="suspensionDate" [(ngModel)]="startDate"
						class="form-control">
				</div>
				<div class="col-sm form-group">
					<label for="returnDate" class="form-label">Final</label>
					<input type="date" name="returnDate" id="returnDate" [(ngModel)]="endDate"
						class="form-control">
				</div>
				<div class="col-sm-auto form-group d-flex justify-end items-end">
					<button class="btn btn-success" (click)="getSuspensions()" [disabled]="searching">
						<i *ngIf="!searching" class="fa fa-search"></i>
						<span *ngIf="searching" class="spinner-border spinner-border-sm"></span>
						Buscar
					</button>
				</div>
			</div>
			<div class="table-responsive mt-2">
				<table class="table table-bordered caption-top">
					<thead>
						<tr>
							<th class="td-center">Empleado</th>
							<th>Fecha Inicio</th>
							<th>Fecha Retorno</th>
						</tr>
					</thead>
					<tbody>
						<ng-container *ngFor="let item of suspensions">
							<tr>
								<td>{{item.employeeData.nombre}}</td>
								<td>{{item.startDate | date:'dd-MM-YYYY'}}</td>
								<td
									class="d-flex justify-center items-center"
									style="max-width: 120px; min-width: 100%"
								>
									<div *ngIf="editingItem !== item.id">
										<span
											(click)="startEditing(item.id)"
											class="profit-ammount"
										>
											{{item.endDate? (item.endDate | date:'dd-MM-YYYY') : 'INDEFINIDO'}}
											<i class="fa fa-edit span-hover"></i>
										</span>
									</div>

									<div
										*ngIf="editingItem === item.id"
										class="input-group input-group-sm"
									>
										<input
											#newDate
											type="date"
											name="end"
											[value]="item.endDate"
											style="text-align: center"
											id="profit"
											class="form-control"
										/>
										<button
											class="btn btn-success"
											[disabled]="loading[item.id]"
											(click)="
												setEndDate(
													item,
													newDate.value
												)
											"
										>
											<ng-container
												*ngIf="!loading[item.id]"
											>
												<i class="fa fa-floppy-disk"></i>
											</ng-container>
											<ng-container
												*ngIf="loading[item.id]"
											>
												<span
													class="spinner-border spinner-border-sm"
													aria-hidden="true"
												></span>
												<span role="status"></span>
											</ng-container>
										</button>
									</div>
								</td>
							</tr>
						</ng-container>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</div>